import React, { useEffect, useRef, useState } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import { TextStyle, FontFamily, FontSize } from '@tiptap/extension-text-style';
import { FiBold, FiItalic, FiUnderline, FiList, FiSmile } from 'react-icons/fi';

const FONTS =['Arial', 'Georgia', 'Times New Roman', 'Calibri', 'Verdana', 'Courier New', 'Tahoma'];
const SIZES = [['Small', '12px'], ['Normal', '14px'], ['Large', '18px'], ['Huge', '24px']];
// Categorized emoji picker — a broad set grouped like a phone keyboard.
const EMOJI_GROUPS = [
  { tab: '😀', name: 'Smileys', list: ('😀😃😄😁😆😅🤣😂🙂🙃😉😊😇🥰😍🤩😘😗😚😙🥲😋😛😜🤪😝🤑🤗🤭🤫🤔🤐🤨😐😑😶😏😒🙄😬🤥😌😔😪🤤😴😷🤒🤕🤢🤮🤧🥵🥶🥴😵🤯🤠🥳🥸😎🤓🧐😕😟🙁☹️😮😯😲😳🥺😦😧😨😰😥😢😭😱😖😣😞😓😩😫🥱😤😡😠🤬😈👿💀💩🤡👹👺👻👽👾🤖😺😸😹😻😼😽🙀😿😾').match(/./gu) },
  { tab: '👍', name: 'Gestures', list: ('👋🤚🖐✋🖖👌🤌🤏✌️🤞🤟🤘🤙👈👉👆🖕👇☝️👍👎✊👊🤛🤜👏🙌👐🤲🤝🙏✍️💅🤳💪🦾🦵🦶👂🦻👃🧠🫀🫁🦷🦴👀👁👅👄💋🩸').match(/./gu) },
  { tab: '🧑', name: 'People', list: ('👶🧒👦👧🧑👨👩🧔🧓👴👵🙍🙎🙅🙆💁🙋🧏🙇🤦🤷👮🕵️💂🥷👷🤴👸👳👲🧕🤵👰🤰🤱👼🎅🤶🦸🦹🧙🧚🧛🧜🧝🧞🧟💆💇🚶🧍🧎🏃💃🕺👯🧖👫👬👭').match(/./gu) },
  { tab: '❤️', name: 'Hearts', list: ('❤️🧡💛💚💙💜🖤🤍🤎💔❣️💕💞💓💗💖💘💝💟♥️💌💤💢💣💥💦💨🕳️💫⭐🌟✨⚡🔥🌈☀️').match(/./gu) },
  { tab: '🐶', name: 'Animals', list: ('🐶🐱🐭🐹🐰🦊🐻🐼🐨🐯🦁🐮🐷🐸🐵🙈🙉🙊🐒🐔🐧🐦🐤🦆🦅🦉🦇🐺🐗🐴🦄🐝🐛🦋🐌🐞🐜🦗🕷️🦂🐢🐍🦎🦖🦕🐙🦑🦐🦀🐡🐠🐟🐬🐳🐋🦈🐊🐅🐆🦓🦍🐘🦏🐪🐫🦒🐃🐂🐄🐎🐖🐏🐑🐐🦌🐕🐩🐈🐓🦃🕊️🐇🐁🐀🐿️🦔🐾🐉🌵🎄🌲🌳🌴🌱🌿☘️🍀🎍🎋🍃🍂🍁🍄🌾💐🌷🌹🥀🌺🌸🌼🌻🌙').match(/./gu) },
  { tab: '🍔', name: 'Food', list: ('🍏🍎🍐🍊🍋🍌🍉🍇🍓🫐🍈🍒🍑🥭🍍🥥🥝🍅🍆🥑🥦🥬🥒🌶️🌽🥕🧄🧅🥔🍠🥐🥯🍞🥖🥨🧀🥚🍳🧈🥞🧇🥓🥩🍗🍖🌭🍔🍟🍕🥪🥙🧆🌮🌯🥗🥘🍝🍜🍲🍛🍣🍱🥟🍤🍙🍚🍘🍥🥠🥮🍢🍡🍧🍨🍦🥧🧁🍰🎂🍮🍭🍬🍫🍿🍩🍪🌰🥜🍯🥛🍼☕🍵🧃🥤🍶🍺🍻🥂🍷🥃🍸🍹🍾🧊').match(/./gu) },
  { tab: '⚽', name: 'Activity', list: ('⚽🏀🏈⚾🥎🎾🏐🏉🥏🎱🪀🏓🏸🏒🏑🥍🏏🥅⛳🪁🏹🎣🤿🥊🥋🎽🛹🛷⛸️🥌🎿⛷️🏂🪂🏋️🤼🤸🤺🏇🧘🏄🏊🤽🚣🧗🚵🚴🏆🥇🥈🥉🏅🎖️🎗️🎫🎟️🎪🤹🎭🎨🎬🎤🎧🎼🎹🥁🎷🎺🎸🪕🎻🎲♟️🎯🎳🎮🎰🧩').match(/./gu) },
  { tab: '🚗', name: 'Travel', list: ('🚗🚕🚙🚌🚎🏎️🚓🚑🚒🚐🚚🚛🚜🛴🚲🛵🏍️🛺🚨🚔🚍🚘🚖🚡🚠🚟🚃🚋🚞🚝🚄🚅🚈🚂🚆🚇🚊🚉✈️🛫🛬🛩️💺🚁🛸🚀🛰️🛶⛵🚤🛥️🛳️⛴️🚢⚓⛽🚧🚦🚥🗺️🗿🗽🗼🏰🏯🏟️🎡🎢🎠⛲🏖️🏝️🏜️🌋⛰️🏔️🗻🏕️⛺🏠🏡🏢🏬🏣🏥🏦🏨🏪🏫⛪🕌').match(/./gu) },
  { tab: '💡', name: 'Objects', list: ('⌚📱📲💻⌨️🖥️🖨️🖱️💽💾💿📀📷📸📹🎥📽️🎞️📞☎️📟📠📺📻🎙️🧭⏱️⏲️⏰🕰️⌛⏳📡🔋🔌💡🔦🕯️🧯🛢️💸💵💴💶💷💰💳💎⚖️🧰🔧🔨⚒️🛠️⛏️🔩⚙️🧱⛓️🧲🔫💣🔪🗡️⚔️🛡️🚬⚰️🏺🔮📿🧿💈⚗️🔭🔬💊💉🩹🩺🌡️🧹🧺🧻🚽🚿🛁🛀🧼🪥🧽🧴🛎️🔑🗝️🚪🪑🛋️🛏️🧸🖼️🛍️🛒🎁🎈🎏🎀🎊🎉✉️📩📨📧💌📥📤📦🏷️📪📫📬📭📮📜📃📄📑📊📈📉🗒️🗓️📆📅📇🗃️📋📁📂🗂️🗞️📰📓📔📒📕📗📘📙📚📖🔖🔗📎🖇️📐📏🧮📌📍✂️🖊️🖋️✒️🖌️🖍️📝✏️🔍🔎🔒🔓').match(/./gu) },
  { tab: '🔣', name: 'Symbols', list: ('✅❌⭕🛑⛔📛🚫💯💢♨️🚭❗❕❓❔‼️⁉️⚠️🚸⚜️🔱📶🔰♻️✳️❇️✴️❎🌐💠Ⓜ️🏧🚾♿🅿️🚹🚺🚼🚻🚮🔞📵🈲🉑㊙️㊗️🈺🈵💹💲💱™️©️®️🔚🔙🔛🔝🔜✔️☑️🔘⚪⚫🔴🔵🟤🟣🟢🟡🟠🔺🔻🔸🔹🔶🔷🔳🔲▪️▫️◾◽◼️◻️🟥🟧🟨🟩🟦🟪⬛⬜🟫➕➖➗✖️♾️➡️⬅️⬆️⬇️↗️↘️↙️↖️↕️↔️↩️↪️🔀🔁🔂🔄▶️⏸️⏯️⏹️⏺️⏭️⏮️⏩⏪🔼🔽🔊🔉🔈🔇🔔🔕📣📢💬💭🗯️♠️♣️♥️♦️🕐🕑🕒🕓🕔🕕🕖🕗🕘🕙🕚🕛').match(/./gu) },
];

/**
 * Rich-text email body editor. Emits onChange(html, plainText) on every change.
 * `valueHtml` seeds the initial content (and re-syncs if changed externally, e.g. a reply prefill).
 */
export default function EmailEditor({ valueHtml, onChange, placeholder, minHeight = 160 }) {
  const [showEmoji, setShowEmoji] = useState(false);
  const [emojiCat, setEmojiCat] = useState(0);
  const emojiRef = useRef(null);

  const editor = useEditor({
    extensions: [
      StarterKit.configure({}),
      Underline,
      TextStyle,
      FontFamily,
      FontSize,
    ],
    content: valueHtml || '',
    onUpdate: ({ editor }) => onChange(editor.getHTML(), editor.getText()),
    editorProps: {
      attributes: {
        style: `min-height: ${minHeight}px; max-height: 340px; overflow-y: auto; padding: 12px; outline: none; font-size: 14px; line-height: 1.5;`,
      },
    },
  });

  // Re-seed when the parent swaps content (reply/forward prefill, or reset to empty after send).
  useEffect(() => {
    if (!editor) return;
    if ((valueHtml || '') !== editor.getHTML()) {
      editor.commands.setContent(valueHtml || '', false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueHtml, editor]);

  // Close the emoji popover on outside click.
  useEffect(() => {
    const onDoc = (e) => { if (emojiRef.current && !emojiRef.current.contains(e.target)) setShowEmoji(false); };
    if (showEmoji) document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [showEmoji]);

  if (!editor) return null;

  const btn = (active) => ({
    padding: '5px 8px', background: active ? '#2563eb' : 'white', color: active ? 'white' : '#374151',
    border: '1px solid #e5e7eb', borderRadius: 4, cursor: 'pointer', fontSize: 13,
    display: 'flex', alignItems: 'center', gap: 4, lineHeight: 1,
  });
  const sel = { padding: '5px 6px', border: '1px solid #e5e7eb', borderRadius: 4, fontSize: 12.5, background: 'white', cursor: 'pointer' };

  return (
    <div style={{ border: '1px solid #d1d5db', borderRadius: 8, overflow: 'visible', background: 'white' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: 8, borderBottom: '1px solid #e5e7eb', background: '#f9fafb', alignItems: 'center', position: 'relative' }}>
        <button type="button" onClick={() => editor.chain().focus().toggleBold().run()} style={btn(editor.isActive('bold'))} title="Bold"><FiBold size={14} /></button>
        <button type="button" onClick={() => editor.chain().focus().toggleItalic().run()} style={btn(editor.isActive('italic'))} title="Italic"><FiItalic size={14} /></button>
        <button type="button" onClick={() => editor.chain().focus().toggleUnderline().run()} style={btn(editor.isActive('underline'))} title="Underline"><FiUnderline size={14} /></button>
        <div style={{ width: 1, background: '#e5e7eb', margin: '0 2px', alignSelf: 'stretch' }} />
        <button type="button" onClick={() => editor.chain().focus().toggleBulletList().run()} style={btn(editor.isActive('bulletList'))} title="Bulleted list"><FiList size={14} /></button>
        <button type="button" onClick={() => editor.chain().focus().toggleOrderedList().run()} style={btn(editor.isActive('orderedList'))} title="Numbered list">1.</button>
        <div style={{ width: 1, background: '#e5e7eb', margin: '0 2px', alignSelf: 'stretch' }} />
        <select style={sel} title="Font" defaultValue="" onChange={(e) => {
          const f = e.target.value;
          if (f) editor.chain().focus().setFontFamily(f).run(); else editor.chain().focus().unsetFontFamily().run();
        }}>
          <option value="">Font</option>
          {FONTS.map(f => <option key={f} value={f} style={{ fontFamily: f }}>{f}</option>)}
        </select>
        <select style={sel} title="Size" defaultValue="" onChange={(e) => {
          const s = e.target.value;
          if (s) editor.chain().focus().setFontSize(s).run(); else editor.chain().focus().unsetFontSize().run();
        }}>
          <option value="">Size</option>
          {SIZES.map(([label, val]) => <option key={val} value={val}>{label}</option>)}
        </select>
        <div style={{ width: 1, background: '#e5e7eb', margin: '0 2px', alignSelf: 'stretch' }} />
        <div ref={emojiRef} style={{ position: 'relative' }}>
          <button type="button" onClick={() => setShowEmoji(s => !s)} style={btn(showEmoji)} title="Emoji"><FiSmile size={14} /></button>
          {showEmoji && (
            <div style={{ position: 'absolute', top: '110%', left: 0, zIndex: 50, background: 'white', border: '1px solid #e5e7eb', borderRadius: 8, boxShadow: '0 6px 20px rgba(0,0,0,0.15)', width: 320, overflow: 'hidden' }}>
              {/* category tabs */}
              <div style={{ display: 'flex', borderBottom: '1px solid #eef2f7', padding: '4px 4px', gap: 2, overflowX: 'auto' }}>
                {EMOJI_GROUPS.map((g, i) => (
                  <button key={g.name} type="button" title={g.name} onClick={() => setEmojiCat(i)}
                    style={{ fontSize: 16, lineHeight: 1, background: emojiCat === i ? '#eef2ff' : 'none', border: 'none', borderRadius: 6, cursor: 'pointer', padding: '5px 6px', flexShrink: 0 }}>{g.tab}</button>
                ))}
              </div>
              {/* grid — stays open so you can add several */}
              <div style={{ padding: 8, maxHeight: 236, overflowY: 'auto', display: 'grid', gridTemplateColumns: 'repeat(8, 1fr)', gap: 2 }}>
                {EMOJI_GROUPS[emojiCat].list.map((em, i) => (
                  <button key={em + i} type="button" onClick={() => editor.chain().focus().insertContent(em).run()}
                    style={{ fontSize: 20, background: 'none', border: 'none', cursor: 'pointer', padding: 3, borderRadius: 4 }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'none'}>{em}</button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <EditorContent editor={editor} placeholder={placeholder} />
    </div>
  );
}
